import { useSession } from "../app/store";

/**
 * "deliver" switch for the dev-loop run buttons (Triggers, Analysis). Shares one session-wide
 * flag so flipping it on one page applies to the other; resets to off on reload.
 */
export function DeliverToggle({ disabled, disabledReason }: { disabled?: boolean; disabledReason?: string }) {
  const on = useSession((s) => s.devDeliver);
  const setOn = useSession((s) => s.setDevDeliver);
  const active = on && !disabled;
  return (
    <label
      className={`deliver-toggle small${active ? " on" : ""}${disabled ? " disabled" : ""}`}
      title={
        disabled && disabledReason
          ? disabledReason
          : "Also route the rendered reports through the project's subscriptions.yaml (SFTP / email / webhook ... sinks). Off by default; resets on reload."
      }
    >
      <input type="checkbox" checked={on} disabled={disabled} onChange={(e) => setOn(e.target.checked)} />
      deliver
    </label>
  );
}
